import { render, staticRenderFns } from "./examinat.vue?vue&type=template&id=cbba8894&scoped=true"
import script from "./examinat.vue?vue&type=script&lang=js"
export * from "./examinat.vue?vue&type=script&lang=js"
import style0 from "./examinat.vue?vue&type=style&index=0&id=cbba8894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbba8894",
  null
  
)

export default component.exports